import { useEffect, useState } from "react";
import { TextInput, InputChip } from "@chr/eds-react";
import { Stack } from "@mui/material";

export type MultipleTextInputProps = React.ComponentProps<typeof TextInput> & {
  values: string[];
  onAddValue: (value: string) => void;
  onRemoveValue: (value: string) => void;
};

export const MultipleTextInput = ({
  values,
  onAddValue,
  onRemoveValue,
  ...textInputProps
}: MultipleTextInputProps) => {
  const inputId = textInputProps.id ?? 'TextMultipleInput';
  const [addValue, setAddValue] = useState('');

  useEffect(() => {
    const node = document.getElementById(inputId);
    node?.addEventListener("keyup", (event) => {
      if (event.code === "Enter" || event.code === "Space") {
        setAddValue((event.target as HTMLInputElement).value);
      }
    });
  }, [])

  // Cannnot call onAddValue within the EventListener callback since it encapsulates the context
  // instead rely on component state changes to trigger the function call
  useEffect(() => {
    if(addValue){
      onAddValue(addValue);
      setAddValue('');
    }
  }, [addValue, onAddValue])

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if(textInputProps.value !== e.target.value.trimEnd()){
      textInputProps.onChange(e);
    }
  }

  return (
    <Stack spacing={1}>
      <TextInput
        {...textInputProps}
        id={inputId}
        onChange={onChange}
        onBlur={(e)=> {
          setAddValue(e.target.value)
          textInputProps.onBlur && textInputProps.onBlur(e)}}
      />
      {values && values.length > 0 && (
        <Stack spacing={1}>
          {values.map((value, index) => (
            <InputChip
              key={index + value}
              label={value}
              onDelete={() => {
                onRemoveValue(value);
              }}
              variant='outlined'
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
